import { mxCellState } from 'mxgraph-js';
import HCLTreeMxCellRenderer from '../HCLCellRenderer/HCLTreeMxCellRenderer';
import HCLTreeVertex from '../HCLTreeNode/HCLTreeVertex';
import BadgeHandler from "../HCLText/Badge/BadgeHandler";
import SubLabelHandler from "../HCLText/SubLabel/SubLabelHandler";

class HCLVertexState extends mxCellState {
  private badgeHandler: BadgeHandler = new BadgeHandler(this);

  private labelHandler: SubLabelHandler = new SubLabelHandler(this);

  public handleTextUpdate(): void {
    this.badgeHandler.updateText();
    this.labelHandler.updateText();
  }

  public handleTextInit(renderer: HCLTreeMxCellRenderer): void {
    this.badgeHandler.initText(renderer);
    this.labelHandler.initText(renderer);
  }

  public handleTextDestroy(): void {
    this.badgeHandler.destroyText();
    this.labelHandler.destroyText();
  }

  getCell(): HCLTreeVertex {
    return this.cell as HCLTreeVertex;
  }
}

export default HCLVertexState;
